import React, { useEffect, useState } from "react";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import Switch from "@mui/material/Switch";
import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";

const MenusScreen = ({ setMostrarMenu, idmodulo, descripcion, idusuario }) => {
  const history = useHistory();
  const [usuarioMenus, setUsuarioMenus] = useState([]);
  const [permisosArray, setPermisosArray] = useState([]);

  const handleSwitchChange = (idmenu, idrel, isChecked) => {
    setUsuarioMenus((prevUsuarioMenus) =>
      prevUsuarioMenus.map((item) =>
        item.idmenu === idmenu ? { ...item, acceso: isChecked } : item
      )
    );

    const existingPermission = permisosArray.find(
      (permiso) => permiso.idmenu === idmenu
    );
    if (existingPermission) {
      setPermisosArray((prevPermisosArray) =>
        prevPermisosArray.map((permiso) =>
          permiso.idmenu === idmenu
            ? { ...permiso, estatus: isChecked }
            : permiso
        )
      );
    } else {
      setPermisosArray((prevPermisosArray) => [
        ...prevPermisosArray,
        { idmenu, idrel, idusuario, estatus: isChecked },
      ]);
    }
  };

  const confirmGuardar = async () => {
    const { value } = await Swal.fire({
      title: "Confirmar",
      text: `¿Desea modificar ${permisosArray.length} permisos?`,
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Guardar",
      reverseButtons: true,
    });

    if (value) {
      // Usuario confirmó, realiza la acción
      onGuardar();
    } else {
      // Usuario canceló, borra todos los elementos de permisosArray
      history.push("/Permisos/PermisosUsuarios");
    }
  };

  const onGuardar = async () => {
    try {
      for (const post of permisosArray) {
        await request.post(`MenuUsuarios`, post);
      }
      await Swal.fire({
        title: "MODIFICACION DE PERMISOS",
        text: "Permisos actualizados con éxito",
        icon: "success",
        customClass: {
          container: "mi-superpoop",
        },
      });
      //   history.push("/Permisos/PermisosUsuarios");
      setPermisosArray([]);
      onUpdate();
    } catch (error) {
      Swal.fire("PERMISOS", JSON.stringify(error), "error");
    }
  };

  const onCerrar = () => {
    setMostrarMenu(false);
  };

  const onUpdate = () => {
    request
      .get(
        `MenuUsuarios/ListadoUsuarioMenu?idusuario=${Number(
          idusuario
        )}&idmodulo=${Number(idmodulo)}`
      )
      .then((result) => {
        setUsuarioMenus(result);
      })
      .catch((error) => {
        Swal.fire("LISTADO USUARIOS-MENU", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    onUpdate();
  }, [idmodulo]);

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };
  return (
    <div className="permisos-usuarios-menus-main-usuarios-screen-container">
      <div className="tabla-relacion-usuarios-menu scroll 4">
        <table>
          <thead>
            <tr>
              <th colSpan={2}>Menú {capitalizeWords(descripcion)}</th>
            </tr>
          </thead>

          <tbody>
            {usuarioMenus.map((item) => (
              <tr key={item.idmenu}>
                <td>{capitalizeWords(item.descripcion)}</td>
                <td>
                  <Switch
                    checked={item.acceso}
                    onChange={(event) =>
                      handleSwitchChange(
                        item.idmenu,
                        item.idrel,
                        event.target.checked
                      )
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="permisos-usuarios-agregar-permisos-menu-button-container">
        <Button variant="contained" color="error" onClick={() => onCerrar()}>
          Cerrar
        </Button>
        <Button variant="contained" onClick={() => confirmGuardar()}>
          Guardar
        </Button>
      </div>
    </div>
  );
};

export default MenusScreen;
